import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/scroll-test',
            name: 'admin-scroll-test',
            component: () => import(/* webpackChunkName: "page-admin-default-scroll-test" */ `./index.vue`),
            meta: {
                data_for_admin_layout: {
                    data_for_history_tag: {
                        entity: {
                            name: "滚动测试",
                        }
                    },
                    data_for_breadcrumb: {
                        entity_list: [
                            {
                                name: "示例功能"
                            },
                            {
                                name: "滚动测试"
                            }
                        ]
                    }
                }
            },

        }
    ],
};
